import { render, staticRenderFns } from "./myShopOrderReturn.vue?vue&type=template&id=fc2c3e1a&scoped=true"
import script from "./myShopOrderReturn.vue?vue&type=script&lang=js"
export * from "./myShopOrderReturn.vue?vue&type=script&lang=js"
import style0 from "./myShopOrderReturn.vue?vue&type=style&index=0&id=fc2c3e1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2c3e1a",
  null
  
)

export default component.exports